import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { Toaster } from 'sonner';

import App from '@/app/router';
import { AuthProvider } from '@/lib/auth/AuthProvider';
import { PortalAuthProvider } from '@/lib/portal-auth/PortalAuthProvider';
import { ModeProvider } from '@/lib/mode/ModeProvider';
import { ThemeReady } from '@/components/ThemeReady';
import { ConfirmDialogProvider } from '@/components/ui/confirm-dialog';
import '@/styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <ThemeReady />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <PortalAuthProvider>
              <ModeProvider>
                <ConfirmDialogProvider>
                  <App />
                  <Toaster richColors position="top-right" closeButton />
                </ConfirmDialogProvider>
              </ModeProvider>
            </PortalAuthProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
